import { render, staticRenderFns } from "./cModalViewDet.vue?vue&type=template&id=6f6f5db8&scoped=true"
import script from "./cModalViewDet.vue?vue&type=script&lang=js"
export * from "./cModalViewDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f5db8",
  null
  
)

export default component.exports